import type { DriveStep } from "driver.js";

export const BOOKINGS_TOUR_STEPS: DriveStep[] = [
  {
    element: '[data-tour="bookings-status-tabs"]',
    popover: {
      title: "Statusfilter",
      description:
        "Filtern Sie nach allen Buchungen, offenen Anfragen, abgelehnten Anfragen, bestätigten/aktiven Aufenthalten oder bereits abgereisten Gästen. Neue Online-Anfragen erscheinen unter „Angefragt“.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="bookings-search"]',
    popover: {
      title: "Suche",
      description:
        "Durchsuchen Sie Buchungen nach Nummer, Gastname, Platz, Kennzeichen, Status oder Datum.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="bookings-create"]',
    popover: {
      title: "Neue Buchung",
      description:
        "Legen Sie eine Reservierung manuell an: Gast wählen, Zeitraum und Platzkategorie festlegen, optional direkt einen Stellplatz zuweisen.",
      side: "left",
      align: "center",
    },
  },
  {
    element: '[data-tour="bookings-table"]',
    popover: {
      title: "Buchungsliste",
      description:
        "Klicken Sie auf eine Zeile für Details. Bei Anfragen öffnet sich der Bestätigungsdialog; bei bestätigten Buchungen die Aufenthaltsübersicht mit Rechnungen und Aktionen.",
      side: "top",
      align: "start",
    },
  },
];
